import React, { Component } from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';

class LoadingIndicator extends Component {

  constructor (props) {
    super(props);

    this.state = {};
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
  }

  render () {
    return (
      <View
        style={styles.container}>
        <ActivityIndicator
          animating
          color='#6b7adc'
          size='large'
          style={styles.indicator}/>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0, left: 0, bottom: 0, right: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  indicator: {},
});

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/common/LoadingIndicator.js